export default "__VITE_ASSET__CmmMJAvZ__"